import { Grid, Typography, List, ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react';
import { motion } from 'framer-motion';
import banner from '../../images/academics/science.png';

const benefits = [
  { text: 'The science stream offers a wide range of exciting career opportunities.' },
  { text: 'It helps you develop critical thinking and problem-solving skills.' },
  { text: 'It provides a strong foundation for higher education in various fields.' },
  { text: 'You get to stay connected with the latest technological advancements.' },
  { text: 'It allows you to contribute to solving global challenges and making a difference.' }
];

const AcademicsPage = () => {
  return (
    <Box sx={{ padding: { xs: 4, sm: 6, md: 10 }, background: 'var(--background-light)' }}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Typography
              variant='h3'
              sx={{
                fontSize: { md: '40px', xs: '32px', sm: '36px' },
                fontWeight: 800,
                color: 'var(--primary-dark)',
                mb: 4
              }}
            >
              Benefits of Choosing the Science Stream
            </Typography>
            <List sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {benefits.map((benefit, index) => (
                <ListItem key={index} disableGutters sx={{ alignItems: 'flex-start' }}>
                  <ListItemIcon sx={{ minWidth: '40px', mt: 0.5 }}>
                    <CheckCircleIcon sx={{ color: 'var(--secondary-color)', fontSize: '28px' }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={benefit.text}
                    primaryTypographyProps={{
                      fontSize: { md: '18px', xs: '16px' },
                      color: 'var(--text-secondary)',
                      lineHeight: 1.6
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '-20px',
                right: '-20px',
                width: '100%',
                height: '100%',
                background: 'var(--primary-color)',
                borderRadius: '24px',
                opacity: 0.1,
                zIndex: 0
              }}
            />
            <Box sx={{ width: '100%', maxWidth: '500px', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.15)', zIndex: 1 }}>
              <img src={banner} alt="Science stream benefits" style={{ width: '100%', height: 'auto', display: 'block' }} />
            </Box>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AcademicsPage;
